/**
 * @example
 *  - ['expense-code']
 *  - ['expense-code', 'list', <filters>]
 *  - ['expense-code', 'detail', <id>]
 */
const ExpenseCodeQueryKeys = {
  all: () => ['expense-code'] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...ExpenseCodeQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id?: number) =>
    [
      ...ExpenseCodeQueryKeys.all(),
      'detail',
      ...(id !== undefined ? [id] : [])
    ] as const
};

export default ExpenseCodeQueryKeys;
